<script setup lang="ts">
import LeInflectionSchemeTable from "@/components/articles/dictsys/inflection-schemes/LeInflectionSchemeTable.vue";
import { DictsysFrenchNounInflectionSchemeHelper } from "@/helpers";
import type { DictsysFrenchNounInflectionScheme } from "@/types";

const props = defineProps<{
  lemma: string;
  inflectionScheme: DictsysFrenchNounInflectionScheme;
  language: string;
}>();
</script>

<template>
  <div class="le-french-noun-inflection-scheme">
    <LeInflectionSchemeTable
      :tables="DictsysFrenchNounInflectionSchemeHelper.getTables(props.inflectionScheme)"
      :language="props.language"
    />
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-french-noun-inflection-scheme {
  display: flex;
  flex-direction: column;
  gap: 10px;

  #media-breakpoint-up(lg, {
    gap: 30px;
  });
}
</style>
